module.exports = __webpack_public_path__ + "img/r3c2.6f465009.jpg";